<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList('main')" v-focus>
			<div class="button action input-go" @click="getList('main')"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.hidden ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hidden')"></span>
				<label>Hidden</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.not_taxable ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_taxable')"></span>
				<label>Not Taxable</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.call_to_order ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('call_to_order')"></span>
				<label>Call To Order</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.pickup_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('pickup_only')"></span>
				<label>Pickup Only</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div>
			<div :class="['button', hasFilters ? 'neutral' : 'disabled']" @click="clearFilters()">Clear Filters</div>
			<div class="message">{{ exportMessage }}</div>
		</div>
        <div v-if="getDevEnvironment"  class="divider"></div>
        <div v-if="getDevEnvironment" class="extra-menu-item" @click="getList('main')">Reload List</div>
	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Description</th>
					<th class="list center">Hidden</th>
					<th class="list center">Call</th>
					<th v-if="!getAdministratorFlag" class="list center">Not Taxable</th>
					<th v-if="!getAdministratorFlag" class="list center">Pickup Only</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list left">{{ item.description }}</td>
				<td class="list center"><i v-if="item.hidden" class="fas fa-check"></i></td>
				<td class="list center"><i v-if="item.call_to_order" class="fas fa-check"></i></td>
				<td v-if="!getAdministratorFlag" class="list center"><i v-if="item.not_taxable" class="fas fa-check"></i></td>
				<td v-if="!getAdministratorFlag" class="list center"><i v-if="item.pickup_only" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>Edit {{ listDetail.description }} Department</h2>

			<div class="content">
				<label>Description</label>
				<input type="text" v-model="listDetail.description" :disabled="!userCanEdit"/>
				<label>Link</label>
				<input type="text" v-model="listDetail.link_name" :disabled="!userCanEdit"/>
				<div style="margin: 0.5em 0 0 0;">
					<input type="checkbox" v-model="listDetail.hidden" value="1" /> Hidden from website
				</div>
				<div style="margin: 0.5em 0 0 0;">
					<input type="checkbox" v-model="listDetail.call_to_order" value="1" /> Show products as "Call to Order"
				</div>
				<div v-if="!getAdministratorFlag" style="margin: 0.5em 0 0 0;">
					<input type="checkbox" v-model="listDetail.not_taxable" value="1" /> Not Taxable
				</div>
				<div v-if="!getAdministratorFlag" style="margin: 0.5em 0 0 0;">
					<input type="checkbox" v-model="listDetail.pickup_only" value="1" /> Pickup In Store Only
				</div>
				<div class="message-overlay" v-if="modalMessage">
					<p>{{ modalMessage }}</p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="backToList()">Cancel</div>
				<div :class="['button', 'spaced', !canSave || saving ? 'disabled' : 'action']" @click="saveItem()">Save department</div>
			</div>
		</div>
	</div>


</div>

</template>

<script>
export default {
	name: 'departments',

	data() {
		return {
			client_id: '',
            loading: true,
			filters: {},
			list: [],
			mergeList: [],
			paging: {},
			showModal: false,
			gettingExport: false,
			listDetail: {},
			exportMessage: '',
			exporting: false,
			saving: false,
			modalMessage: '',
			modalSuccess: false,
		}
	},
	created() {
		this.clearFilters()
	},
	computed: {
		canSave() {
			return this.listDetail.description
		},
		userCanEdit() {
			return this.getAdministratorFlag
		},
		hasFilters() {
			return this.filters.search_term || this.filters.hidden
		}
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				current_id: '',
				hidden: 0,
				inactive: 0,
				do_export: 0
			}
			this.getList('main')
		},
		getList(context) {
			this.loading = true
			this.apiCall({ destination: 'get_list_departments', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.filters.page = 1
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.exporting = false
						this.exportMessage = ''
					}, 1500)
				} else {
						this.list = obj.departments
						if (obj.paging) {
							this.paging = obj.paging
						}
					}

			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
			this.mergeList = []
			this.filters.merge_search_term = ''
			this.loading = true
			this.showModal = true
			this.apiCall({ destination: 'get_item_department', data: { department_id: item.department_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.listDetail = obj.department
					this.filters.current_id = this.listDetail.department_id
				} else {
					this.modalMessage = obj.message
				}
			})
		},
		setMerge(department) {
			this.listDetail.merge_into = department.department_id
			this.filters.merge_search_term = department.description
			this.mergeList = []
		},
		addItem() {
			this.listDetail = {
				department_id: 'new',
				client_id: this.client_id,
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.userCanEdit = true
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.modalSuccess = false
			this.modalMessage = 'Saving department...'
			this.apiCall({ destination: 'save_item_department', data: this.listDetail }).then(obj => {
				if (obj.status == 'success') {
					this.modalMessage = 'Department saved!'
					this.modalSuccess = true
					setTimeout(() => {
						this.backToList()
						this.getList()
						this.modalMessage = ''
						this.saving = false
					}, 2000);
				} else {
					this.modalMessage = obj.message
					setTimeout(() => {
						this.modalMessage = ''
						this.saving = false
					}, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showModal = false
			this.current_id = ''
			this.listDetail = {}
		}
	}
}
</script>

<style lang="scss" scoped>
.modal .inner {
  max-height: 50em;
  max-width: 50em;
}
</style>
